module.exports = __webpack_public_path__ + "img/1.8ef794b8.png";